/**
 * FTA 협정 메타정보 — 관세청 공개 정보(FTA 포털) 기준 사실 데이터.
 *   발효일·대상국가·원산지증명 발급방식·증명서 유효기간.
 * ⚠ 참고용. 품목별 원산지결정기준(PSR)·세부 요건·최신 개정은 관세청 원문/FTA-PASS 확인.
 *   (CLHS 등 타사 가공물이 아니라 관세청 원천 사실만 정리)
 *
 * resolveFtaByCode("FEU1") → EU 협정 객체. 미등록 코드는 null.
 */
const AG = {
  efta: {
    name: "한·EFTA FTA",
    effective: "2006-09-01",
    members: "스위스 · 노르웨이 · 아이슬란드 · 리히텐슈타인",
    coMethod: "자율발급(수출자)",
    coValid: "12개월",
  },
  eu: {
    name: "한·EU FTA",
    effective: "2011-07-01",
    members: "EU 27개국",
    coMethod: "자율발급(원산지신고서, €6,000 초과 시 인증수출자)",
    coValid: "12개월",
  },
  gb: {
    name: "한·영국 FTA",
    effective: "2021-01-01",
    members: "영국",
    coMethod: "자율발급(원산지신고서, 인증수출자)",
    coValid: "12개월",
  },
  us: {
    name: "한·미 FTA",
    effective: "2012-03-15",
    members: "미국",
    coMethod: "자율발급(수출자·생산자·수입자)",
    coValid: "4년",
  },
  cn: {
    name: "한·중 FTA",
    effective: "2015-12-20",
    members: "중국",
    coMethod: "기관발급",
    coValid: "12개월",
  },
  jp: {
    name: "RCEP(한·일은 RCEP으로만 특혜)",
    effective: "2022-02-01",
    members: "일본 (RCEP 회원국)",
    coMethod: "기관발급 또는 자율발급(인증수출자)",
    coValid: "12개월",
  },
  asean: {
    name: "한·아세안 FTA",
    effective: "2007-06-01",
    members:
      "브루나이 · 캄보디아 · 인도네시아 · 라오스 · 말레이시아 · 미얀마 · 필리핀 · 싱가포르 · 태국 · 베트남",
    coMethod: "기관발급(AK Form)",
    coValid: "12개월",
  },
  vn: {
    name: "한·베트남 FTA",
    effective: "2015-12-20",
    members: "베트남",
    coMethod: "기관발급(VK Form)",
    coValid: "12개월",
  },
  in: {
    name: "한·인도 CEPA",
    effective: "2010-01-01",
    members: "인도",
    coMethod: "기관발급",
    coValid: "12개월",
  },
  id: {
    name: "한·인도네시아 CEPA",
    effective: "2023-01-01",
    members: "인도네시아",
    coMethod: "기관발급 또는 자율발급(인증수출자)",
    coValid: "12개월",
  },
  sg: {
    name: "한·싱가포르 FTA",
    effective: "2006-03-02",
    members: "싱가포르",
    coMethod: "기관발급",
    coValid: "12개월",
  },
  kh: {
    name: "한·캄보디아 FTA",
    effective: "2022-12-01",
    members: "캄보디아",
    coMethod: "기관발급 또는 자율발급",
    coValid: "12개월",
  },
  ph: {
    name: "한·필리핀 FTA",
    effective: "2024-12-31",
    members: "필리핀",
    coMethod: "기관발급 또는 자율발급",
    coValid: "12개월",
  },
  au: {
    name: "한·호주 FTA",
    effective: "2014-12-12",
    members: "호주",
    coMethod: "기관발급 또는 자율발급",
    coValid: "2년",
  },
  nz: {
    name: "한·뉴질랜드 FTA",
    effective: "2015-12-20",
    members: "뉴질랜드",
    coMethod: "자율발급(수출자·생산자)",
    coValid: "2년",
  },
  cl: {
    name: "한·칠레 FTA",
    effective: "2004-04-01",
    members: "칠레",
    coMethod: "자율발급(수출자)",
    coValid: "2년",
  },
  pe: {
    name: "한·페루 FTA",
    effective: "2011-08-01",
    members: "페루",
    coMethod: "자율발급(수출자)",
    coValid: "12개월",
  },
  co: {
    name: "한·콜롬비아 FTA",
    effective: "2016-07-15",
    members: "콜롬비아",
    coMethod: "자율발급(수출자)",
    coValid: "12개월",
  },
  ca: {
    name: "한·캐나다 FTA",
    effective: "2015-01-01",
    members: "캐나다",
    coMethod: "자율발급(수출자·생산자)",
    coValid: "2년",
  },
  tr: {
    name: "한·튀르키예 FTA",
    effective: "2013-05-01",
    members: "튀르키예",
    coMethod: "자율발급(수출자)",
    coValid: "12개월",
  },
  il: {
    name: "한·이스라엘 FTA",
    effective: "2022-12-01",
    members: "이스라엘",
    coMethod: "자율발급(수출자)",
    coValid: "12개월",
  },
  ae: {
    name: "한·UAE CEPA",
    effective: "발효 절차 진행(서명 2024)",
    members: "아랍에미리트",
    coMethod: "관세청 원문 확인",
    coValid: "관세청 원문 확인",
  },
  central: {
    name: "한·중미 FTA",
    effective: "2019-10-01(국가별 순차)",
    members:
      "코스타리카 · 엘살바도르 · 니카라과 · 온두라스 · 파나마 · 과테말라",
    coMethod: "자율발급(수출자·생산자)",
    coValid: "12개월",
  },
  rcep: {
    name: "RCEP(역내포괄적경제동반자협정)",
    effective: "2022-02-01(한국 발효)",
    members: "아세안 10개국 + 한국 · 중국 · 일본 · 호주 · 뉴질랜드 (15개국)",
    coMethod: "기관발급 또는 자율발급(인증수출자)",
    coValid: "12개월",
  },
};

// 협정세율 코드 → 협정 키. 긴 prefix 우선 매칭.
const PREFIX = [
  ["FRC", "rcep"],
  ["FCECR", "central"],
  ["FCESV", "central"],
  ["FCEHN", "central"],
  ["FCENI", "central"],
  ["FCEPA", "central"],
  ["FCEGT", "central"],
  ["FEF", "efta"],
  ["FEU", "eu"],
  ["FGB", "gb"],
  ["FUS", "us"],
  ["FCN", "cn"],
  ["FAS", "asean"],
  ["FVN", "vn"],
  ["FIN", "in"],
  ["FID", "id"],
  ["FSG", "sg"],
  ["FKH", "kh"],
  ["FPH", "ph"],
  ["FAU", "au"],
  ["FNZ", "nz"],
  ["FCL", "cl"],
  ["FPE", "pe"],
  ["FCO", "co"],
  ["FCA", "ca"],
  ["FTR", "tr"],
  ["FIL", "il"],
  ["FAE", "ae"],
];

// 협정 키 → 관세청 FTA 포털 ftaId(KOR+2자). PSR 프록시 조회용.
const KOR_FTA_ID = {
  efta: "KOREF",
  eu: "KOREU",
  gb: "KORGB",
  us: "KORUS",
  cn: "KORCN",
  jp: "KORRC",
  asean: "KORAS",
  vn: "KORVN",
  in: "KORIN",
  id: "KORID",
  sg: "KORSG",
  kh: "KORKH",
  ph: "KORPH",
  au: "KORAU",
  nz: "KORNZ",
  cl: "KORCL",
  pe: "KORPE",
  co: "KORCO",
  ca: "KORCA",
  tr: "KORTR",
  il: "KORIL",
  ae: "KORAE",
  central: "KORMA",
  rcep: "KORRC",
};

export function resolveFtaByCode(code) {
  const c = String(code || "").toUpperCase();
  // 긴 prefix 먼저(FCECR vs FCN 등 충돌 방지) — 길이 내림차순
  const sorted = [...PREFIX].sort((a, b) => b[0].length - a[0].length);
  for (const [p, key] of sorted) {
    if (c.startsWith(p)) {
      const ag = AG[key];
      return ag ? { ...ag, key, ftaId: KOR_FTA_ID[key] || null } : null;
    }
  }
  return null;
}
